import { render, staticRenderFns } from "./AttachmentCreate.vue?vue&type=template&id=f603596e&scoped=true"
import script from "./AttachmentCreate.vue?vue&type=script&lang=js"
export * from "./AttachmentCreate.vue?vue&type=script&lang=js"
import style0 from "./AttachmentCreate.vue?vue&type=style&index=0&id=f603596e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f603596e",
  null
  
)

export default component.exports